// A square button with an arrow that goes around: start a match again from
// the seed in the settings. It has no word. Its name is for a screen reader.

import { el } from '../lib/dom';
import { svg } from '../lib/svg';

const ICON_BOX = 24;
/** Three quarters of a ring, open at the top. */
const ARC_PATH = 'M17.3 6.7 A7.5 7.5 0 1 1 6.7 6.7';
/** The head of the arrow, at the end of the arc. */
const HEAD_POINTS = '10.6,2.8 10.2,10.2 3.2,3.2';

/** Plain words, not final copy. */
const RESTART_LABEL = 'Restart from seed';
const RESTART_TIP = 'Start a match from the seed below.';

export const createRestartButton = (onclick: () => void): HTMLButtonElement =>
  el(
    'button',
    {
      className: 'button button--pass-through menu__restart',
      type: 'button',
      ariaLabel: RESTART_LABEL,
      dataset: { tip: RESTART_TIP },
      onclick,
    },
    [
      svg(
        'svg',
        {
          class: 'menu__restart-icon',
          viewBox: `0 0 ${ICON_BOX} ${ICON_BOX}`,
          'aria-hidden': 'true',
        },
        [
          svg('path', { class: 'menu__restart-arc', d: ARC_PATH }),
          svg('polygon', { points: HEAD_POINTS }),
        ],
      ),
    ],
  );
